import TaskZoneModel          from 'Models/intervention/TaskZoneModel';
import TaxZoneModel           from 'Models/invoice/TaxZoneModel';
import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('Propriétaire site')
@model.urnResource('owner_location')
@doc.path('/owner_locations/{?id}')
export default class OwnerLocationModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'locationUrn': Urn;
		'taxZone': id;
		'taxZone.code': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare locationUrn: Urn;
	@doc.model(TaxZoneModel) declare taxZone: TaxZoneModel;
	@model.resolvable(TaskZoneModel, { attributeName: 'locationUrn' }) declare location: TaskZoneModel;
}
